var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"red--text text-center w-100"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }